<template>
  <div class="container products-wrap px-2 py-2 border">
      <div class="title-wrap border-bottom mb-3">
        <h1>{{$ml.with('VueJS').get('RequestsModerationTitle')}}</h1>
      </div>

      <div class="list-wrap" v-if="itemsList.length > 0">
          <div class="pagination-wrap" v-if="pageCount > 1">
              <b-pagination
                      v-model="currentPage"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      :disabled="isLoading"
                      size="sm"
              ></b-pagination>
          </div>

          <b-table
                  striped
                  hover
                  small
                  id="items-list"
                  :items="itemsList"
                  :fields="fields"
          >
              <template v-slot:cell(actions)="row">
                  <b-button @click="approve(row)" size="sm" class="mr-1" variant="success">
                      <font-awesome-icon icon="thumbs-up"></font-awesome-icon>
                  </b-button>
                  <b-button @click="decline(row)" size="sm" variant="danger">
                      <font-awesome-icon icon="ban"></font-awesome-icon>
                  </b-button>
              </template>
          </b-table>

          <div class="pagination-wrap" v-if="pageCount > 1">
              <b-pagination
                      v-model="currentPage"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      :disabled="isLoading"
                      size="sm"
              ></b-pagination>
          </div>

          <div class="text-right">{{$ml.with('VueJS').get('Page')}}: {{ currentPage }} / {{ pageCount }}</div>
      </div>

      <b-modal id="itemParams" hide-footer title="Параметры" v-model="showItemParams">
          <div class="params-wrap">

          </div>
      </b-modal>
  </div>
</template>

<style>
    .b-form-file {
        overflow: hidden;
    }
</style>
<script>
  import mixinUtils from "@/components/mixinUtils";

  export default {
    name: 'pharm-company-products',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      filter: {
        pcId: null,
      },
      currentProduct: {

      },
      fields: [
        {
          key: 'id',
          label: '#',
          sortable: false
        },
        {
          key: 'request_id',
          label: 'Номер заявки',
          sortable: false
        },
        {
          key: 'product.ru_name',
          label: 'Наименование',
          sortable: false
        },
        /*{
          key: 'product.ru_name',
          label: 'Производитель',
          sortable: false
        },*/
        {
          key: 'storage.name',
          label: 'Склад',
          sortable: false
        },
        {
          key: 'actions',
          label: '',
        }
      ],
      showItemParams: false,
      itemsList: [],
      pharmCompaniesList: [],
      isLoading: false,
      currentPage: 1,
      pageCount: 1,
      totalCount: null,
      perPage: 20,
    }),
    methods: {
      approve(row) {
        const contex = this
        const items = [
          { good_id: row.item.good_id, request_id: row.item.request_id, storage_id: row.item.storage_id }
        ]
        contex.apiCall(`requests/approve-request-items`, 'post', {items: items})
          .then(function (response) {
            if (response.data.status === 200 && response.data.errors.length === 0) {
              contex.$bvToast.toast(`Продукт успешно одобрен`, {
                title: 'Модерация продуктов',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              contex.getItems()
            } else {
              contex.$bvToast.toast(`Ошибка: ${response.data.errors[0]}`, {
                title: 'Модерация продуктов',
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      },
      decline(row) {
        const contex = this
        const items = [
          { good_id: row.item.good_id, request_id: row.item.request_id, storage_id: row.item.storage_id }
        ]
        contex.apiCall(`requests/decline-request-items`, 'post', {items: items})
          .then(function (response) {
            if (response.data.status === 200 && response.data.errors.length === 0) {
              contex.$bvToast.toast(`Продукт успешно отклонен`, {
                title: 'Модерация продуктов',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })

              contex.getItems()
            } else {
              contex.$bvToast.toast(`Ошибка: ${response.data.errors[0]}`, {
                title: 'Модерация продуктов',
                autoHideDelay: 5000,
                variant: 'danger',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      },
      showItemParamsModal(row) {
        this.showItemParams = true
        console.log(row)
      },
      setItemParams () {
        const contex = this
        if (contex.isLoading) return;

      },
      getItems () {
        const contex = this
        if (contex.isLoading) return;

        contex.isLoading = true
        const pharmCompanyId = contex.filter.pcId ? contex.filter.pcId : ''
        contex.apiCall(`requests/items-for-moderation?expand=good,product,request,storage&pc_id=${pharmCompanyId}&page=${contex.currentPage}&per-page=${contex.perPage}`, 'post', {})
          .then(function (response) {
            /*if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно получены`, {
                title: 'Список продуктов на модерацию',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            contex.itemsList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]

              contex.itemsList.push(data)
            }

            contex.currentPage = response.data._meta.currentPage
            contex.pageCount = response.data._meta.pageCount
            contex.totalCount = response.data._meta.totalCount

            contex.isLoading = false
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      },
      getPharmcompanies () {
        const contex = this

        contex.apiCall(`pharmcompany/index?page=1&per-page=10000`, 'post', {})
          .then(function (response) {
            /*if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно получены`, {
                title: 'Список фарм компаний',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }*/

            contex.pharmCompaniesList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]
              contex.pharmCompaniesList.push(data)
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {

        })
      }
    },
    mounted() {
      const context = this
      context.getPharmcompanies()
      context.getItems()
    },
    watch: {
      currentPage: {
        // eslint-disable-next-line no-unused-vars
        handler: function(newVal, oldVal) {
          this.getItems()
        }
      }
    },
    computed: {
      availablePharmCompanies () {
        const options = []
        for (let i = 0; i < this.pharmCompaniesList.length; i++) {
          const item = this.pharmCompaniesList[i]
          options.push({
            value: item.id,
            text: item.name,
          })
        }
        return options
      },
    }
  }
</script>